const SHARE_TYPE_OPTIONS = {
  PUBLIC: 'public',
  CUSTOM: 'custom',
  PRIVATE: 'private',
} as const

type ShareType = (typeof SHARE_TYPE_OPTIONS)[keyof typeof SHARE_TYPE_OPTIONS]

export { type ShareType, SHARE_TYPE_OPTIONS }
